module.exports = __webpack_public_path__ + "img/male_img.293bb013.png";